import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAvature } from '../Services/Operations/ProductAPI';
import { useNavigate } from 'react-router';
import { setAvature } from '../Redux/user_information';

const Avatar = () => {
    const token = useSelector((state) => state.user.token);
    const [images, setImages] = useState([]);
    const BASE_URL = "https://zotpot.in";
    const navigate = useNavigate();
    const dispatch = useDispatch();  
    useEffect(() => {
        const fetchAvatars = async () => {
            try {
                const formData = new FormData();
                formData.append("token", token);

                const response = await getAvature(formData);
                setImages(response.data);  
                //console.log("Avature : ", response);
            } catch (error) {
                console.error("Error fetching avatars:", error);
            }
        };
        fetchAvatars();
    }, [token]);

    const handleAvatarClick = (selectedAvatar) => {
        dispatch(setAvature(selectedAvatar));  
        //console.log("Selected Avatar:", selectedAvatar);
        navigate("/profile")
    };

    return (
        <div style={{ padding: "0px 20px" }}>
            <h4 style={{ fontSize: "20px" }}>Choose your avatar</h4>
            <div style={{
                display: "flex", flexWrap: "wrap", alignItems: "center",
                justifyContent: "flex-start",
                marginBottom: "40px",
            }}>
                {images.map((image, index) => (
                    <div key={index} onClick={() => handleAvatarClick(`${BASE_URL}${image}`)} style={{ cursor: 'pointer', margin: '10px' }}>
                        <img width="110px" src={`${BASE_URL}${image}`} alt={`Avatar ${index + 1}`} />
                    </div>
                ))}
            </div>
            <div style={{ width: "100%" }}>
                <button onClick={() => navigate("/profile")} style={{
                    padding: "5px 9px", display: "flex",
                    margin: "auto"
                }}>Go back</button>
            </div>
        </div>
    );
};

export default Avatar;
